import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteNonAllocatedSim = async (id: number): Promise<boolean> =>
  axios.delete(`/Management/NonAllocatedSim/DeleteNonAllocatedSim?id=${id}`).then((res) => res?.data?.result)

type Props = {
  id: number
}

export const useManagementDeleteNonAllocatedSim = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['createNonAllocatedSims'],
    mutationFn: ({ id }: Props) => deleteNonAllocatedSim(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted non allocated sim.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete non allocated sim.')
      }
    },
    throwOnError: false
  })
